import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStaffAccess } from '../../../utils/staffAccess';

export function StaffManagementGate({ children }) {
  const { canAccessStaffManagement } = useStaffAccess();
  if (!canAccessStaffManagement()) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}

export function StaffActivitiesGate({ children }) {
  const { canViewStaffActivities } = useStaffAccess();
  if (!canViewStaffActivities()) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}

export function SystemConfigGate({ children }) {
  const { canViewSystemConfig } = useStaffAccess();
  if (!canViewSystemConfig()) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}
